import { render } from "./SelectProduct.vue?vue&type=template&id=c1f7cf1a"
import script from "./SelectProduct.vue?vue&type=script&lang=js"
export * from "./SelectProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__